"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chips = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Chip_1 = require("./Chip");
const PresentationContext_1 = require("./PresentationContext");
const Css_1 = require("../Css");
/** Renders a list of `Chip`s, with wrapping & appropriate margin between each `Chip`. */
function Chips(props) {
    const { wrap: presentationWrap } = (0, PresentationContext_1.usePresentationContext)();
    const { values, compact, xss = {}, wrap = presentationWrap } = props;
    return ((0, jsx_runtime_1.jsx)("div", { css: {
            ...Css_1.Css.df.aifs.gap1.whiteSpace("normal").$,
            ...(wrap !== false ? Css_1.Css.add({ flexWrap: "wrap" }).$ : {}),
            ...xss,
        }, children: values.map((value, i) => {
            const { text, title } = (value.hasOwnProperty("text") ? value : { text: value });
            return (0, jsx_runtime_1.jsx)(Chip_1.Chip, { text: text, title: title, compact: compact }, i);
        }) }));
}
exports.Chips = Chips;
